import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Helpers
import { cloneDeep } from "lodash";
import { switchTreeOrdering } from "@/Washouts/helpers/SideTree";

// Layouts
import AppSideBar from "@/Layouts/components/SideBars/AppSideBar";

// Icons
import OptionsMenuIcon from "@/assets/icons/svg/OptionsMenuIcon";

// Constants
const OPTIONS_ICON_CLASSES = "side-selector-more-btn";
const EMPLOYEE_ORDER_LABEL = "By Employee";
const CYCLE_ORDER_LABEL = "By Commission Cycle";

export default function WashoutsSideBar(props) {
	const {
		selected = "",
		toggleTitle = EMPLOYEE_ORDER_LABEL,
		treeDefinition = {},
		expanded = [],
		loading = false,
		optionsDisabled = false,
		onSelectAction = () => {},
		onOrderByAction = () => {},
	} = props;
	const { tree = [] } = treeDefinition;

	const [order, setOrder] = useState(toggleTitle);

	const handleOrder = () => {
		const newOrder = order === EMPLOYEE_ORDER_LABEL ? CYCLE_ORDER_LABEL : EMPLOYEE_ORDER_LABEL;
		setOrder(newOrder);
		onOrderByAction?.(newOrder);
	};

	useEffect(() => {
		return () => {
			// Cleanup
			setOrder(EMPLOYEE_ORDER_LABEL);
		};
	}, []);

	const renderTree = order === EMPLOYEE_ORDER_LABEL ? tree : switchTreeOrdering(cloneDeep(tree));

	return (
		<AppSideBar
			searchProps={{
				searchBy: "name",
				loading,
			}}
			sideBarProps={{
				loading,
				selected,
				expanded,
				onSelectAction,
				height: "515px",
				showBy: "name",
				disabled: loading,
				tree: renderTree,
			}}
			actions={{
				loading,
				alignment: "end",
				disabled: optionsDisabled,
				operations: [
					{
						loading,
						identifier: "options",
						classes: "h-[51px] w-[51px] less-opacity-disabled",
						color: "var(--gray-blue-color)",
						icon: <OptionsMenuIcon classes={OPTIONS_ICON_CLASSES} disabled={optionsDisabled} sx={{ fontSize: "29px" }} />,
						iconHover: <OptionsMenuIcon classes={OPTIONS_ICON_CLASSES} hoverVariant={true} sx={{ fontSize: "29px" }} />,
						disabled: optionsDisabled,
						menus: [
							{
								label: order,
								classes: "!font-sans text-[16px] !text-default",
								onClick: handleOrder,
							},
						],
					},
				],
			}}
		/>
	);
}
WashoutsSideBar.propTypes = {
	selected: PropTypes.string,
	toggleTitle: PropTypes.string,
	treeDefinition: PropTypes.shape({
		tree: PropTypes.array,
		activeCommissionCycles: PropTypes.array,
	}),
	expanded: PropTypes.array,
	loading: PropTypes.bool,
	optionsDisabled: PropTypes.bool,
	onSelectAction: PropTypes.func,
	onOrderByAction: PropTypes.func,
};
